
import Vue, { PropType } from 'vue';
import Btn from '../button/Button.vue';
import Icon, { Icon as IconName } from '../icon/Icon.vue';

export default Vue.extend({
    components: {
        Btn,
        Icon
    },

    props: {
        icon: {
            type: String as PropType<IconName>,
            required: true
        },
        tooltip: {
            type: String as PropType<string>,
            default: undefined
        },
        ariaLabel: {
            type: String as PropType<string>,
            default: undefined
        },
        alignTooltipLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    }
});
